import { z } from "zod";

/**
 * These common types are defined here and should be used in place of their raw
 * representations. This allows the type generation script to replace their
 * values with aliases (instead of just `string`), which is easier to understand
 * when looking at types at a glance.
 */

const objectId = z.string().regex(/^[0-9a-fA-F]{24}$/);
const uuid = z.guid();
const date = z.iso.date();
const dateTime = z.iso.datetime({ offset: true });
const dateTimeNoOffset = z.iso.datetime();
const dateTimeLocal = z.iso.datetime({ local: true });
const dateTimeNoT = z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/);
const dateTimeNoSeconds = z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/);
const unixTimestamp = z.int().nonnegative();
const nameStoreToken = z.string().regex(/^[1-9][0-9]*$/);

/**
 * Like a zod.enum, but for a set of numeric values.
 */
function numericEnum<U extends number, T extends readonly [U, ...U[]]>(values: T): z.ZodSchema<T[number]> {
  return z.union(
    values.map((value) => z.literal(value)),
    {
      error: () => {
        return {
          message: `Invalid option: expected one of ${values.map((v) => v.toString()).join("|")}`,
        };
      },
    }
  );
}

export const common = {
  objectId,
  uuid,
  date,
  dateTime,
  dateTimeNoOffset,
  dateTimeLocal,
  dateTimeNoT,
  dateTimeNoSeconds,
  unixTimestamp,
  nameStoreToken,
  numericEnum,
} as const;
